import { render, staticRenderFns } from "./UserAssetAddresses.vue?vue&type=template&id=2a49b23f"
import script from "./UserAssetAddresses.vue?vue&type=script&lang=js"
export * from "./UserAssetAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a49b23f')) {
      api.createRecord('2a49b23f', component.options)
    } else {
      api.reload('2a49b23f', component.options)
    }
    module.hot.accept("./UserAssetAddresses.vue?vue&type=template&id=2a49b23f", function () {
      api.rerender('2a49b23f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assets/UserAssetAddresses.vue"
export default component.exports